/**
 * iOS will not autoplay unless the element is muted + playsinline, and even then
 * the `autoPlay` attribute is not enough — Safari needs an explicit play() and
 * hides a giant start-playback overlay if those flags are missing.
 */
export const playMutedInlineVideo = (video: HTMLVideoElement): void => {
  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.controls = false;
  video.setAttribute('playsinline', 'true');
  video.setAttribute('webkit-playsinline', 'true');
  video.setAttribute('muted', '');
  void video.play().catch(() => undefined);
};
